import CustomCard from '../../../../../components/CustomCard';
import DeptSchedule from './DeptSchedule';
import ManageButtonsHeader from './ManageButtonsHeader';
/**
 *
 * @Author: Susana García Rodríguez
 * @JobTitle : Frontend - IBL
 * @Email : sgarcia@ibl.mx
 * @param {string} props.subView - Current active subview identifier.
 * @param {Function} props.handleBtnDinning - Callback to switch to dining view.
 * @param {Function} props.handleBtnSettings - Callback to switch to settings view.
 * @param {Function} props.handleBtnDepartmentPolicies - Callback to switch to department policies view.
 * @param {Function} props.handleBtnTotalMeals - Callback to switch to total meals view.
 * @returns {JSX.Element}
 */
const DepartmentPolicies = ({
    subView,
    handleBtnDinning,
    handleBtnSettings,
    handleBtnDepartmentPolicies,
    handleBtnTotalMeals,
}) => {
    return (
        <div className='row px-0 '>
            <div className='d-flex gap-3 px-0'>
                <ManageButtonsHeader
                    subView={subView}
                    handleBtnDinning={handleBtnDinning}
                    handleBtnSettings={handleBtnSettings}
                    handleBtnDepartmentPolicies={handleBtnDepartmentPolicies}
                    handleBtnTotalMeals={handleBtnTotalMeals}
                />
            </div>
            <CustomCard classCard={'card-border-8px'} classContent={'p-0'} classes={'mt-2 pr-0 pl-0'}>
                <DeptSchedule />
            </CustomCard>
        </div>
    );
};

export default DepartmentPolicies;
